// Account body component for the account page.

// Imports ----------------------------------------------------------------------------------------------------------

import AccountBodyContainer from '@components/atoms/container/accountBodyContainer';
import AccountCmpButton from '@components/elements/account/accountCmpButton';
import AccountHeader from './accountHeader';
import AccountInfo from './accountInfo';

/**
 * Account body component for the account page.
 * Handles the account information display and CMP integration.
 *
 * @returns {JSX.Element} Account body component
 */
export default function AccountBody() {
  // Render
  return (
    <AccountBodyContainer>
      <AccountHeader />
      <AccountInfo />
      <AccountCmpButton />
    </AccountBodyContainer>
  );
}
